import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Button, Result, Spin } from 'antd';
import CheckoutLayout from '../components/CheckoutLayout';
import { getPayment } from '../api/payment';
import { getDefaultMerchantName } from '../utils/site';

const STATUS_MAP = {
  SUCCESS: 'success',
  PENDING: 'info',
  CREATED: 'info',
  CLOSED: 'warning',
  FAILED: 'error',
};

export default function ResultPage() {
  const [searchParams] = useSearchParams();
  const merchantOrderNo = searchParams.get('merchant_order_no');
  const gatewayOrderNo = searchParams.get('gateway_order_no');
  const [loading, setLoading] = useState(Boolean(gatewayOrderNo));
  const [order, setOrder] = useState(null);

  useEffect(() => {
    if (!gatewayOrderNo) {
      return;
    }
    getPayment(gatewayOrderNo, true)
      .then((res) => {
        if (res.code === 0) {
          setOrder(res.data);
        }
      })
      .finally(() => setLoading(false));
  }, [gatewayOrderNo]);

  if (loading) {
    return (
      <div className="checkout-loading">
        <Spin size="large" />
      </div>
    );
  }

  const status = order?.status || 'PENDING';
  const resultStatus = STATUS_MAP[status] || 'info';

  return (
    <CheckoutLayout merchantName={getDefaultMerchantName()} logoText="PG">
      <Result
        status={resultStatus}
        title={status === 'SUCCESS' ? 'Payment Successful' : `Payment ${status}`}
        subTitle={
          merchantOrderNo
            ? `Merchant order: ${merchantOrderNo}`
            : gatewayOrderNo
              ? `Gateway order: ${gatewayOrderNo}`
              : 'You have returned from the payment channel.'
        }
        extra={[
          gatewayOrderNo && (
            <Link to={`/pay/status/${gatewayOrderNo}?merchant_order_no=${merchantOrderNo || ''}`} key="status">
              <Button type="link">View details</Button>
            </Link>
          ),
          <Link to="/pay" key="retry">
            <Button type="primary" style={{ background: '#1a5c3a' }}>New payment</Button>
          </Link>,
        ].filter(Boolean)}
      />
    </CheckoutLayout>
  );
}
